<template>
  <div class="casino-demo-items">
    <a href="javascript:;">
      <img v-lazy="game.thumb_1" :alt="game.title" loading="lazy" decoding="async" />
    </a>
    <div class="casino-overlay">
      <div class="cmn-grp text-center">
        <h6 class="text-white">{{ game.title }}</h6>
        <a
          href="javascript:;"
          class="cmn--btn video-btn"
          @click.prevent="
            $router.push({ name: 'game.show', params: { slug: game.slug } })
          "
        >
          <span>{{ $t("Play") }}</span>
        </a>
        <a href="javascript:;" class="border-btn" @click.prevent="doLike">
          <span>{{ is_favorited ? $t("Dislike"): $t("Like") }}</span>
          <!-- <i v-if="is_favorited" class="fas fa-heart text-white" style="color: white !important;"></i>
          <i v-else class="far fa-heart text-white" style="color: white !important;"></i> -->
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { useGamesStore } from "@/store/games";
import { mapActions } from "pinia";
import helpers from "@/helpers";

export default {
  name: "GameCard",
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      is_favorited: false,
    };
  },
  methods: {
    ...mapActions(useGamesStore, ["toggleFavorites"]),
    async doLike() {
      const result = await this.toggleFavorites(this.game.id);
      if(result === false) {
        helpers.showToast(this.$t("Failed to like game"), this.$t("Internal Error"), "error");
      } else {
        this.is_favorited = !this.is_favorited;
        helpers.showToast(result, this.$t("Completed Success"), "success");
      }
    }
  },
  mounted() {
    this.is_favorited = this.game.is_favorited
  },
};
</script>

<style scoped>
.casino-demo-items {
  aspect-ratio: 4 / 3;
  border-radius: 10px;
  background-color: var(--footer, #1a1a2e);
}

.casino-demo-items img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
</style>